<template>
  <new-route />
</template>

<script>
import NewRoute from "@/components/3pl/Settings/RoutesAndVehicles/Routes/TerminalToDoor/NewRoute/index";
export default {
  components: {
    NewRoute,
  },
};
</script>

<style></style>
